import React from 'react';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import { Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import CSVReader from 'react-csv-reader';

import ListSettingsModal from '../ListSettingsModal';
import CustomPagination from '../../CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';
import EditListSettingsForm from '../ListSettingsForm/EditListSettingsForm';
import Loader from '../../Loader';

import { openListSettingsModal } from '../../../actions/siteadmin/modalActions';
import { getAdminListingSettings } from '../../../actions/siteadmin/getAdminListingSettings';
import { makeModelCsvUploader } from '../../../actions/siteadmin/MakeModelCsvUploader/makeModelCsvUploader';
import messages from '../../../locale/jsonMessages';

import { withQuery } from '../../../hoc/withGraphql';
import { getAllAdminListSettings } from '../../../lib/graphql';

import showToaster from '../../../helpers/toasterMessages/showToaster';
import { getDynamicAdminItemName } from '../../../helpers/GetDynamicItemName/getDynamicName';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

import importIcon from '/public/AdminIcons/adminImportIcon.svg';
import toolTipIcon from '/public/AdminIcons/toolTipIcon.svg';

import Toaster from '../../Toaster/Toaster';
import cs from '../../../components/commonStyle.css';
import s from './ListSettingsManagement.css';

class ListSettingsManagement extends React.Component {

  static defaultProps = {
    loading: true
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: '',
      typing: false,
      typingTimeout: 0
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.typeId !== this.props.typeId) {
      this.setState({
        currentPage: 1,
        searchList: ''
      });
    }
  }

  paginationData = async (currentPage, typeId) => {
    const { getAdminListingSettings, getAllAdminListSettings: { refetch } } = this.props;
    const { searchList } = this.state;
    let variables = {
      currentPage: currentPage,
      searchList: searchList,
      typeId: Number(typeId)
    };
    this.setState({
      currentPage: currentPage,
      searchList: searchList
    })
    refetch(variables);
    await getAdminListingSettings(typeId, currentPage, searchList);
  }

  handleClick = async (searchList) => {
    const { getAdminListingSettings, getAllAdminListSettings: { refetch }, typeId } = this.props;
    let variables = {
      currentPage: 1,
      searchList: searchList,
      typeId: Number(typeId)
    };
    refetch(variables);
    await getAdminListingSettings(variables.typeId, variables.currentPage, variables.searchList);
  }

  handleSearchChange = (e) => {
    const self = this;
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }
    self.setState({
      searchList: e.target.value,
      currentPage: 1,
      typing: false,
      typingTimeout: setTimeout(function () {
        self.handleClick(self.state.searchList);
      }, 450)
    });
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.settingsIDLabel) },
      { data: formatMessage(messages.addNew) },
      { data: formatMessage(messages.status) },
      { data: formatMessage(messages.operationLabel) }
    ]
  };

  tbody = (props) => {
    const { openListSettingsModal } = props;
    const { formatMessage, locale } = this.props.intl;
    const { adminListSettings, getAllAdminListSettings: { loading, getAllAdminListSettings } } = props;
    let listSettingsData;
    if (!loading) {
      listSettingsData = adminListSettings?.getAllAdminListSettings?.listSettingsData || getAllAdminListSettings?.listSettingsData;
    }
    return listSettingsData?.length > 0 && listSettingsData?.map((value, key) => {
      let itemName = value?.dynamicItemName.length > 0 ? getDynamicAdminItemName({ value: value?.itemName, locale, data: value?.dynamicItemName }) : value?.itemName;
      let status = value?.isEnable == 1 ? formatMessage(messages.enabledLabel) : formatMessage(messages.disabledLabel);
      return {
        id: key,
        data: [
          { data: value?.id },
          { data: itemName },
          { data: status },
          {
            data: <div><Button className={cx(cs.btnPrimaryBorder)} onClick={() => openListSettingsModal(value, "EditListSettingsForm")}>
              <FormattedMessage  {...messages.manageLabel} />
            </Button></div>
          },
        ]
      }
    })
  }

  handleForce = async (value) => {
    const { typeId, makeModelCsvUploader, demoRestriction } = this.props;
    let modelIndex, setEmptyValue = this.inputRef.current.value = "";
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    if (value && value.length > 0) {
      let makeIndex = value[0].findIndex(item => item == 'Make');
      modelIndex = typeId == 3 ? value[0].findIndex(item => item == 'Model') : null

      /* Make section. */
      if (typeId == 20) {
        if (makeIndex != 0) {
          showToaster({ messageId: 'csvFormat', toasterType: 'error' })
          setEmptyValue;
          return;
        };
        if (value.length > 0 && !value[0].includes("Make")) {
          showToaster({ messageId: 'csvFormat', toasterType: 'error' })
          setEmptyValue;
          return;
        };
      };

      /* Model Section. */
      if (typeId == 3) {
        if (makeIndex != 0 || modelIndex != 1) {
          showToaster({ messageId: 'csvFormatError', toasterType: 'error' })
          setEmptyValue;
          return;
        };
        if (value.length > 0 && !value[0].includes("Make", "Model")) {
          showToaster({ messageId: 'csvFormatError', toasterType: 'error' })
          setEmptyValue;
          return;
        };
      }
    };
    makeModelCsvUploader({ categoryList: value.splice(1, value.length), typeId, setEmptyValue });
  };

  inputRef = React.createRef();

  renderTable(listSettingsTypeData, listSettingsData, count) {
    const { page, openListSettingsModal, typeId, makeModelCsvUploading } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage } = this.state;
    let currentTypeId = listSettingsTypeData && listSettingsTypeData?.id;

    return (
      <div>
        <ListSettingsModal />
        <div className={cx(cs.displayFlex, cs.spaceBetween, cs.alignCenter, s.gap, cs.spaceBottom5, s.exportSmapleSheetMobileView)}>
          <Button className={cx(cs.btnPrimary)}
            onClick={() => openListSettingsModal({ typeId: listSettingsTypeData?.id }, "AddListSettingsForm")}>
            <FormattedMessage  {...messages.addNewLabel} />
          </Button>

          {

            (typeId == 20 || typeId == 3) && <div>
              <div className={cx(s.importMakeGap, cs.displayFlex, cs.alignCenter, s.exportSmapleSheetMobileView)}>
                <div className={s.tooltipIcon}>
                  <a href={`/export-admin-data?type=make-model`} className={cx(cs.displayFlex, cs.alignCenter, s.tooltipIconGap, cs.siteLinkColor, cs.commonLinkBorder, cs.noTextDecration, cs.fontWeightMedium)}>
                    {formatMessage(messages.sampleSheet)}
                    <img src={toolTipIcon} />
                  </a>
                  <p className={s.toolTipText}>
                    <FormattedMessage  {...messages.sampleSheetTooltipText} />
                  </p>
                </div>
                {makeModelCsvUploading ? <span className={cx(cs.commonLinkBorder, cs.noTextDecration, cs.fontWeightMedium, cs.siteLinkColor)}><FormattedMessage  {...messages.csvImporting} /></span> : <div className={'csvFileImport'}>
                  <CSVReader
                    ref={this.inputRef}
                    onFileLoaded={this.handleForce}
                    onError={(error) => error && showToaster({ messageId: 'commonError', toasterType: 'error', requestMessage: error })}
                    label={
                      <>
                        <span>
                          {typeId == 20 ? formatMessage(messages.importMake) : formatMessage(messages.importModel)}
                        </span>
                        <span>
                          <img src={importIcon} />
                        </span>
                      </>
                    }
                  />
                </div>}
              </div>
            </div>}
        </div>
        <CommonTable
          thead={this.thead}
          tbody={() => this.tbody(this.props)}
          isLink
          isHeadingHide
          isSearch
          onSearch={this.handleSearchChange}
        />

        {
          listSettingsData?.length > 0 && <div>
            <CustomPagination
              total={count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={(e) => this.paginationData(e, currentTypeId)}
              paginationLabel={formatMessage(messages.listSettings)}
            />
          </div>
        }
      </div>
    );

  }

  renderForm(listSettingsTypeData, listSettingsData) {
    let result = listSettingsData?.map((item => {
      if (item?.dynamicItemName?.length == 0) {
        return {
          ...item,
          dynamicItemName: [{
            itemName: item?.itemName,
            otherItemName: item?.otherItemName,
            itemDescription: item?.itemDescription,
            language: 'en'
          }]
        }
      }
      return item;
    }))
    return (
      <EditListSettingsForm
        initialValues={result && result[0]}
        fieldType={listSettingsTypeData?.fieldType}
        title={listSettingsTypeData?.typeLabel}
      />
    );
  }

  render() {
    const { adminListSettings, getAllAdminListSettings: { loading, getAllAdminListSettings } } = this.props;
    let listSettingsTypeData, listSettingsData, count, errorMessage, status;
    const responseData = adminListSettings?.getAllAdminListSettings || getAllAdminListSettings;

    if (!loading && responseData) {
      status = responseData?.status;
      if (status === 200) {
        listSettingsTypeData = responseData?.listSettingsTypeData;
        listSettingsData = responseData?.listSettingsData;
        count = responseData?.count;
      } else {
        errorMessage = responseData?.errorMessage;
      }
    }

    if (loading) {
      return <Loader type={"text"} />;
    } else {
      if (listSettingsTypeData?.fieldType === "numberType") {
        return (
          <div className='siteAdminCenterContainer siteAdminCenterContainerBox'>
            {this.renderForm(listSettingsTypeData, listSettingsData)}
          </div>
        )
      } else {
        return (
          <div>
            <h1 className='siteAdminHeading'>{listSettingsTypeData?.typeLabel}</h1>
            {this.renderTable(listSettingsTypeData, listSettingsData, count)}
          </div>
        )
      }
    }
  }
}

const mapState = (state) => ({
  loading: state?.adminListSettingsData?.loading,
  adminListSettings: state?.adminListSettingsData?.data,
  page: state?.adminListSettingsData?.currentPage,
  searchListData: state?.adminListSettingsData?.searchList,
  makeModelCsvUploading: state?.loader?.makeModelCsvUploading
});

const mapDispatch = {
  openListSettingsModal,
  getAdminListingSettings,
  makeModelCsvUploader,
  demoRestriction
};

export default compose(
  injectIntl,
  withStyles(cs, s),
  connect(mapState, mapDispatch),
  withQuery(getAllAdminListSettings, {
    name: 'getAllAdminListSettings',
    options: (props) => ({
      variables: {
        currentPage: 1,
        searchList: '',
        typeId: Number(props.typeId)
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  })
)(ListSettingsManagement);
